import { Application } from '@hotwired/stimulus';

const app = Application.start();
const controllers = import.meta.glob('./controllers/*_controller.js', { eager: true });

for (const path in controllers) {
    const module = controllers[path];
    const filename = path.split('/').pop().replace('_controller.js', '');
    const identifier = filename.replace(/_/g, '-');
    app.register(identifier, module.default);
}
